import {
  IPhotoGalleryContent,
  InitialOfferContent
} from "../../types/SourceSystem";

export abstract class SourceSystem {
  name?: string;
  photosRequired?: boolean;
  errorUri: string;
  exitUri: string;
  stepCount?: number;
  exitCopyValue: string;
  haveHeaderExit: boolean;
  initialOfferContent?: InitialOfferContent;
  estimatedOfferCTA?: string;
  photoGalleryContent?: IPhotoGalleryContent;
  quickValuation?: boolean;
  showPrivacyStatement?: boolean;
  vehicleNotFoundError: IVehicleNotFoundError;
  ineligibleVehicleError: IIneligibleVehicleError;
  unableToValueError: IUnableToValueError;
  acceptsCommercialVehicles: boolean;
  offerCardNoValuationSecondaryText: string;
  analyticSearchParam?: string;
  analyticsJourney?: string;
  percentageStepper?: { startOffSet: number; endOffSet: number };
  percentageStepperValue?: number | null;
  showEstimatedOfferPartExchange?: boolean;
  isPartExchangeCustomer?: boolean;
  showBranchValuationContent?: boolean;
  showAssumptionQuestionsWithCondition: boolean;
  useTransientErrorComponent: boolean;
  transientError: ITransientError;
  estimatedOfferNoValuationCTACopy: string;
  sendValuationRequestEvent?: boolean;
  getStepperPercentageValue?: (pageName?: string) => number | undefined;
  
  getCTAValue(pageName?: string) {
    return "Continue";
  }

  handleVehicleNotFoundError() {}

  handleIneligibleVehicleError() {}

  handleBlockedRegistration() {}

  handleUnableToValueError(vehicle?: IVehicle) {}

  handleCommercialVehicle(vehicle: IVehicle, appraisalSessionId: string) {}

  handleAssumptionsOnSubmit(fullValuation?: boolean) {}

  getStepNumber(
    condition: boolean,
    stepNumberIfTrue: number,
    stepNumberIfFalse: number
  ): number {
    return condition ? stepNumberIfTrue : stepNumberIfFalse;
  }

  constructor(redirectUri: string, exitUri: string, navigate: INavigate) {
    this.errorUri = redirectUri;
    this.acceptsCommercialVehicles = true;
    this.exitCopyValue = "Exit";
    this.exitUri = exitUri || "https://www.arnoldclark.com";
    this.haveHeaderExit = true;
    this.showAssumptionQuestionsWithCondition = false;
    this.offerCardNoValuationSecondaryText =
      "Your Product Consultant will give you a call to discuss a price once they receive your photos and answers.";
    this.vehicleNotFoundError = {
      vehicleNotFoundErrorContent: {
        stepPercentage: 1,
        primaryButtonText: "Continue",
        errorMain: "Sorry, we can’t find vehicle details for that registration",
        errorHint:
          "Try entering a different registration or contact your Product Consultant for more information.",
        showAltButton: false
      },
      onClickVehicleNotFoundSecondary: () => {}
    };
    this.estimatedOfferCTA = "Save and submit valuation";
    this.useTransientErrorComponent = false;
    this.estimatedOfferNoValuationCTACopy = "Save and submit";
    this.sendValuationRequestEvent = false;
    this.transientError = {
      transientErrorContent: {
      stepPercentage: 1,
      primaryButtonText: "Try again",
      errorMain: "Sorry, we’re having trouble getting your valuation",
      errorHint: "Please try again later or contact your Product Consultant.",
      showAltButton: false
      },
      onClickTransientErrorSecondary: () => {},

      onClickTransientErrorPrimary: () => {
        navigate(`/registration`);
      }
    };

    this.ineligibleVehicleError = {
      ineligibleVehicleErrorContent: {
        stepPercentage: 1,
        primaryButtonText: "Enter a different registration",
        errorMain:
          "Sorry, we’re unable to get an online valuation. This vehicle might be for sale or sold recently.",
        errorHint:
          "Try entering a different registration or contact your Product Consultant.",
        showAltButton: false
      },

      onClickIneligibleVehicleSecondary() {},

      onClickIneligibleVehiclePrimary() {
        navigate(`/registration`);
      }
    };
    this.unableToValueError = {
      unableToValueContent: {
        stepPercentage: 1,
        primaryButtonText: "Enter a different registration",
        errorMain: "Sorry, we’re unable to get an online valuation",
        errorHint:
          "Don’t worry you can still use this vehicle as a trade-in. Continue without it for now, or enter a different registration.",
        showAltButton: false,
        errorBlocked:
          "Sorry, we’re unable to provide a valuation for this vehicle.",
        errorBlockedHint: "Try entering a different registration."
      },

      onClickUnableToValueSecondary() {},

      onClickUnableToValuePrimary() {
        navigate(`/registration`);
      }
    };

    this.handleVehicleNotFoundError = () => {
      navigate("/check-registration");
    };

    this.handleIneligibleVehicleError = () => {
      navigate("/ineligible-vehicle");
    };

    this.handleBlockedRegistration = () => {
      navigate("/unable-to-value");
    };

    this.handleAssumptionsOnSubmit = () => {
      navigate("/initial-offer");
    };
  }
}
